export function isCorporateUser(cassUser) {
  if (!cassUser || typeof cassUser !== "object") {
    return false;
  }
  const ownerType = typeof cassUser.ownerType === "string" ? cassUser.ownerType.trim().toLowerCase() : "";
  return ownerType === "internal";
}
